import moment from 'moment-timezone'
import { BRAZIL_TIMEZONE } from './constants'
import { isBankWorkdayInBrazil } from './logic'

export const subDays = (date: Date | string, days: number): Date => {
  return moment(date).subtract(days, 'days').toDate()
}

export const addDays = (date: Date | string, days: number): Date => {
  return moment(date).add(days, 'days').toDate()
}

export const addSeconds = (date: Date | string, seconds: number): Date => {
  return moment(date).add(seconds, 'seconds').toDate()
}

export const subSeconds = (date: Date | string, seconds: number): Date => {
  return moment(date).add(seconds, 'seconds').toDate()
}

export const differenceInDaysInBrazil = (source: Date | string, target: Date | string): number => {
  const sourceInBrazil = moment.tz(source, BRAZIL_TIMEZONE)
  const targetInBrazil = moment.tz(target, BRAZIL_TIMEZONE)

  return sourceInBrazil.diff(targetInBrazil, 'days')
}

export const differenceInYearsInBrazil = (source: Date, target: Date): number => {
  const sourceInBrazil = moment.tz(source, BRAZIL_TIMEZONE)
  const targetInBrazil = moment.tz(target, BRAZIL_TIMEZONE)

  return sourceInBrazil.diff(targetInBrazil, 'years')
}

export const subDaysInBrazil = (date: Date, days: number): Date => {
  return moment.tz(date, BRAZIL_TIMEZONE).subtract(days, 'days').toDate()
}

export const subHoursInBrazil = (date: Date, hours: number): Date => {
  return moment.tz(date, BRAZIL_TIMEZONE).subtract(hours, 'hours').toDate()
}

export const addHoursInBrazil = (date: Date, hours: number): Date => {
  return moment.tz(date, BRAZIL_TIMEZONE).add(hours, 'hours').toDate()
}

export const addDaysInBrazil = (date: Date | string, days: number): Date => {
  return moment.tz(date, BRAZIL_TIMEZONE).add(days, 'days').toDate()
}

export const addYearsInBrazil = (date: Date, years: number): Date => {
  return moment.tz(date, BRAZIL_TIMEZONE).add(years, 'years').toDate()
}

export const addMonthsInBrazil = (date: Date, months: number): Date => {
  return moment.tz(date, BRAZIL_TIMEZONE).add(months, 'months').toDate()
}

export const subMinutes = (date: Date, minutes: number): Date => {
  return moment(date).subtract(minutes, 'm').toDate()
}

export const addMinutes = (date: Date, minutes: number): Date => {
  return moment(date).add(minutes, 'm').toDate()
}

export const differenceInHoursInBrazil = (source: Date | string, target: Date | string): number => {
  const sourceInBrazil = moment.tz(source, BRAZIL_TIMEZONE)
  const targetInBrazil = moment.tz(target, BRAZIL_TIMEZONE)
  const duration = moment.duration(sourceInBrazil.diff(targetInBrazil))

  return duration.asHours()
}

export const addWeekdays = (date: Date, days: number): Date => {
  const dateMoment = moment.tz(date, BRAZIL_TIMEZONE)

  let daysToAdd = days
  while (daysToAdd > 0) {
    dateMoment.add(1, 'days')

    const toDate = dateMoment.clone().toDate()
    if (isBankWorkdayInBrazil(toDate)) {
      daysToAdd--
    }
  }

  return dateMoment.toDate()
}

export const subWeekdays = (date: Date, days: number): Date => {
  const dateMoment = moment.tz(date, BRAZIL_TIMEZONE)

  let daysToSub = days
  while (daysToSub > 0) {
    dateMoment.subtract(1, 'days')

    const toDate = dateMoment.clone().toDate()
    if (isBankWorkdayInBrazil(toDate)) {
      daysToSub--
    }
  }

  return dateMoment.toDate()
}

export const subMonthsInBrazil = (date: Date, months: number): Date => {
  return moment.tz(date, BRAZIL_TIMEZONE).subtract(months, 'months').toDate()
}

export const addWorkDaysInBrazil = (date: Date | string, daysToAdd: number): Date => {
  let daysAdded = 0
  const momentDate = moment.tz(date, BRAZIL_TIMEZONE)

  while (daysAdded < daysToAdd) {
    momentDate.add(1, 'day')
    if (isBankWorkdayInBrazil(momentDate.toDate())) {
      daysAdded++
    }
  }

  return momentDate.toDate()
}

export const subWorkdaysInBrazil = (date: Date, days: number): Date => {
  let daysToSub = days
  let updatedDate = date

  while (daysToSub > 0) {
    updatedDate = subDaysInBrazil(updatedDate, 1)
    if (isBankWorkdayInBrazil(updatedDate)) {
      daysToSub--
    }
  }

  return updatedDate
}

export const addWorkdaysInBrazil = (date: Date, days: number): Date => {
  let daysToAdd = days
  let updatedDate = date

  while (daysToAdd > 0) {
    updatedDate = addDaysInBrazil(updatedDate, 1)
    if (isBankWorkdayInBrazil(updatedDate)) {
      daysToAdd--
    }
  }

  return updatedDate
}

export const subHours = (date: Date, hours: number): Date => {
  return moment(date).subtract(hours, 'h').toDate()
}

export const addHours = (date: Date, days: number): Date => {
  return moment(date).add(days, 'h').toDate()
}

export const differenceInMinutesInBrazil = (source: Date, target: Date): number => {
  const sourceInBrazil = moment.tz(source, BRAZIL_TIMEZONE)
  const targetInBrazil = moment.tz(target, BRAZIL_TIMEZONE)
  return sourceInBrazil.diff(targetInBrazil, 'minutes')
}

export const differenceInMonthsInBrazil = (source: Date | string, target: Date | string): number => {
  const sourceInBrazil = moment.tz(source, BRAZIL_TIMEZONE)
  const targetInBrazil = moment.tz(target, BRAZIL_TIMEZONE)
  return sourceInBrazil.diff(targetInBrazil, 'months')
}

export const differenceInSecondsInBrazil = (source: Date, target: Date): number => {
  const sourceInBrazil = moment.tz(source, BRAZIL_TIMEZONE)
  const targetInBrazil = moment.tz(target, BRAZIL_TIMEZONE)
  return sourceInBrazil.diff(targetInBrazil, 'seconds')
}

export const subMonths = (date: Date, months: number): Date => {
  return moment(date).subtract(months, 'months').toDate()
}

export const addMonths = (date: Date, months: number): Date => {
  return moment(date).add(months, 'months').toDate()
}

export const utcStartOfSubMonths = (monthToSubtract: number): Date => {
  return moment.tz('UTC').subtract(monthToSubtract, 'months').startOf('month').toDate()
}

export const utcEndOfSubMonths = (monthToSubtract: number): Date => {
  return moment.tz('UTC').subtract(monthToSubtract, 'months').endOf('month').toDate()
}

export const startOfSubMonths = (monthToSubtract: number): Date => {
  return moment().subtract(monthToSubtract, 'months').startOf('month').toDate()
}

export const endOfSubMonths = (monthToSubtract: number): Date => {
  return moment().subtract(monthToSubtract, 'months').endOf('month').toDate()
}
